import {apiPostUpload, apiPostUploadImagen} from './api';

export default class ServicioUpload {
  static uploadCSV(archivo) {
    return apiPostUpload('/upload/csv', archivo);
  }
  static uploadImage(archivo) {
    return apiPostUpload('/upload/image', archivo);
  }
  static uploadImageBlob(archivo) {
    return apiPostUploadImagen('/upload/image', archivo);
  }
  static uploadExcelMuestras(archivo) {
    return apiPostUpload('/upload/MuestrasExcel', archivo);
  }
}
